module.exports = [{
      plugin: require('/Users/yousuf/Sites/doubledip/double.us/node_modules/gatsby-plugin-catch-links/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/yousuf/Sites/doubledip/double.us/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
